/* ============================================================
   OSZEA — Elements section behaviour
   Vanilla JS, dependency-free. Self-initialises and re-binds on
   shopify:section:load so it stays live inside the Theme Editor.
   Scoped to each .oszea-el root so it never touches the theme
   header / footer or other OSZEA sections.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function initElements(root) {
    if (!root || root.dataset.elInit === '1') return;
    root.dataset.elInit = '1';

    /* ---------- Scroll reveal (IO + viewport fallback) ---------- */
    var reveals = $$('.reveal', root);
    function revealInView() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = reveals.length - 1; i >= 0; i--) {
        var r = reveals[i].getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0) { reveals[i].classList.add('in'); reveals.splice(i, 1); }
      }
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in'); io.unobserve(e.target);
            var ix = reveals.indexOf(e.target); if (ix > -1) reveals.splice(ix, 1);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
      reveals.slice().forEach(function (el) { io.observe(el); });
    }
    window.addEventListener('scroll', revealInView, { passive: true });
    window.addEventListener('resize', revealInView, { passive: true });
    requestAnimationFrame(revealInView);
    setTimeout(revealInView, 200);

    /* ---------- Toast ---------- */
    var toastZone = $('.el-toast-zone', root) || (function () {
      var z = document.createElement('div'); z.className = 'el-toast-zone'; root.appendChild(z); return z;
    })();
    function toast(msg) {
      var t = document.createElement('div');
      t.className = 'el-toast';
      t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L20 6"/></svg><span>' + msg + '</span>';
      toastZone.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('show'); });
      setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 400); }, 2600);
    }

    /* ---------- In-section smooth scroll ---------- */
    $$('a[href^="#"]', root).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id === '#' || id.length < 2) return;
        var t = $(id, root) || document.getElementById(id.slice(1));
        if (!t) return;
        e.preventDefault();
        var y = t.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    /* ---------- Colour selectors (variant image swap + ATC variant) ---------- */
    $$('[data-colorset]', root).forEach(function (set) {
      var feature = set.closest('.el-feature') || root;
      var stage = $('.el-feature-stage', feature);
      var labelEl = $('.el-buy-grouplab b', set);
      var priceEl = $('.el-buy-price .amt', set);
      var atc = $('.el-buy-atc', set);
      var btns = $$('.el-colorpick button', set);
      var thumbs = $$('.el-feature-thumb', feature);
      function select(colour, variantId, formattedPrice) {
        btns.forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-colour') === colour); });
        thumbs.forEach(function (t) { t.classList.toggle('active', t.getAttribute('data-colour') === colour); });
        if (stage) $$('.ph, .el-feature-shot', stage).forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-colour') === colour); });
        if (labelEl) labelEl.textContent = colour;
        if (atc && variantId) atc.setAttribute('data-variant-id', variantId);
        if (priceEl && formattedPrice) priceEl.textContent = formattedPrice;
      }
      function handler(el) {
        el.addEventListener('click', function () {
          select(el.getAttribute('data-colour'), el.getAttribute('data-variant-id'), el.getAttribute('data-price'));
        });
      }
      btns.forEach(handler); thumbs.forEach(handler);
    });

    /* ---------- Expandable detail (bag / strap) ---------- */
    $$('.el-detail-toggle', root).forEach(function (btn) {
      var body = btn.nextElementSibling;
      btn.addEventListener('click', function () {
        var open = btn.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (body) body.style.maxHeight = open ? (body.scrollHeight + 'px') : '0px';
      });
    });
    window.addEventListener('resize', function () {
      $$('.el-detail-toggle.open', root).forEach(function (btn) {
        var body = btn.nextElementSibling; if (body) body.style.maxHeight = body.scrollHeight + 'px';
      });
    }, { passive: true });

    /* ---------- Quantity steppers ---------- */
    $$('.el-buy-qty', root).forEach(function (q) {
      var val = $('span', q), n = 1;
      var minus = $('[data-q="-"]', q), plus = $('[data-q="+"]', q);
      if (minus) minus.addEventListener('click', function () { n = Math.max(1, n - 1); val.textContent = n; q.setAttribute('data-qty', n); });
      if (plus) plus.addEventListener('click', function () { n = Math.min(9, n + 1); val.textContent = n; q.setAttribute('data-qty', n); });
    });

    /* ---------- FAQ accordion ---------- */
    $$('.el-faq-item', root).forEach(function (item) {
      var q = $('.el-faq-q', item), a = $('.el-faq-a', item);
      if (!q || !a) return;
      if (item.classList.contains('open')) a.style.maxHeight = a.scrollHeight + 'px';
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        $$('.el-faq-item.open', root).forEach(function (o) {
          if (o !== item) { o.classList.remove('open'); var oa = $('.el-faq-a', o); if (oa) oa.style.maxHeight = '0px'; }
        });
        if (isOpen) { item.classList.remove('open'); a.style.maxHeight = '0px'; }
        else { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
    window.addEventListener('resize', function () {
      var open = $('.el-faq-item.open', root); if (open) { var a = $('.el-faq-a', open); if (a) a.style.maxHeight = a.scrollHeight + 'px'; }
    }, { passive: true });

    /* ---------- Add to Cart / Quick Add (Shopify AJAX cart) ---------- */
    $$('[data-el-add]', root).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var host = btn.closest('.el-buy');
        var qty = 1;
        if (host) { var qEl = $('.el-buy-qty', host); if (qEl) qty = parseInt(qEl.getAttribute('data-qty') || '1', 10); }
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) { toast('Select a colour first'); return; }
        var label = btn.getAttribute('data-add-label') || 'Item';
        addToCart(variantId, qty, label);
      });
    });

    function addToCart(variantId, qty, label) {
      // POST to Shopify AJAX cart, then ask the theme to open its cart drawer.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { toast((res.d && res.d.description) || 'Could not add to cart'); return; }
          toast(label + ' added to cart');
          // Refresh & open the theme cart drawer if the theme supports these events.
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          // Dawn-based themes:
          if (window.Shopify && Shopify.onCartUpdate) { try { Shopify.onCartUpdate(); } catch (e) {} }
          var drawerToggle = document.querySelector('[data-cart-toggle], #cart-icon-bubble, .js-cart-open, cart-drawer');
          if (drawerToggle && drawerToggle.tagName === 'CART-DRAWER' && drawerToggle.open) { try { drawerToggle.open(); } catch (e) {} }
        })
        .catch(function () { toast('Network error — please try again'); });
    }

    /* ---------- Rain canvases (lightweight, pause off-screen) ---------- */
    function initRain(canvas, count, color) {
      if (!canvas || reduce) return;
      var ctx = canvas.getContext('2d');
      var host = canvas.parentElement;
      var W = 0, H = 0, dpr = 1, drops = [], running = false, inView = false;
      function resize() {
        dpr = Math.min(2, window.devicePixelRatio || 1);
        var r = host.getBoundingClientRect(); W = r.width; H = r.height;
        canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      function seed() { drops = []; for (var i = 0; i < count; i++) drops.push({ x: Math.random() * W, y: Math.random() * H, len: 8 + Math.random() * 14, v: 5 + Math.random() * 7, a: 0.04 + Math.random() * 0.12 }); }
      function loop() {
        ctx.clearRect(0, 0, W, H); ctx.lineWidth = 1.1;
        for (var i = 0; i < drops.length; i++) {
          var d = drops[i];
          ctx.strokeStyle = 'rgba(' + color + ',' + d.a + ')';
          ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x - 1.4, d.y + d.len); ctx.stroke();
          d.y += d.v; d.x -= 0.35; if (d.y > H) { d.y = -d.len; d.x = Math.random() * W; }
        }
        if (inView) requestAnimationFrame(loop); else running = false;
      }
      function start() { if (!running) { running = true; requestAnimationFrame(loop); } }
      resize(); seed();
      window.addEventListener('resize', function () { resize(); seed(); }, { passive: true });
      new IntersectionObserver(function (es) { es.forEach(function (e) { inView = e.isIntersecting; if (inView) start(); }); }, { threshold: 0.02 }).observe(host);
    }
    initRain($('[data-rain="hero"]', root), 46, '150,200,212');
    initRain($('[data-rain="band"]', root), 60, '150,200,212');

    /* ---------- Gentle hero parallax ---------- */
    if (!reduce) {
      var fig = $('.el-hero-figure .ph, .el-hero-figure .ph-img', root);
      var hero = $('.el-hero', root);
      if (fig && hero) {
        window.addEventListener('scroll', function () {
          var r = hero.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) return;
          var p = Math.min((window.innerHeight - r.top) * 0.03, 14);
          fig.style.transform = 'translateY(' + (-p) + 'px) scale(1.06)';
        }, { passive: true });
      }
    }
  }

  function boot() { $$('.oszea-el').forEach(initElements); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme Editor: re-init when this section is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.oszea-el') || (e.target.classList && e.target.classList.contains('oszea-el') ? e.target : null);
    if (root) { root.dataset.elInit = ''; initElements(root); }
  });
})();
